import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "environments"
    }}>{`Environments`}</h1>
    <div className="deprecation-message">
  <h2>We're moving our docs!</h2>
  <h3>
    Find{" "}
    <a href="https://depo-platform-documentation.scrollhelp.site/developer-docs/Environment-URLs.1851392210.html">
      the latest version of this page
    </a>{" "}
    on the Platform website.
  </h3>
  <h3>
    Still can't find what you're looking for? Reach out to{" "}
    <a href="https://dsva.slack.com/archives/CBU0KDSB1">
      #vfs-platform-support
    </a>{" "}
    on Slack.
  </h3>
    </div>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Environment`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`site url`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`api url`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`buildtype`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`NODE_ENV`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Deployments`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`localhost`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`http://localhost:3001`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`http://localhost:3000`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`localhost`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`development`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://dev.va.gov"
            }}>{`https://dev.va.gov`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://dev-platform-api.va.gov"
            }}>{`https://dev-platform-api.va.gov`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`vagovdev`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`After a merge to main`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`staging`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://staging.va.gov"
            }}>{`https://staging.va.gov`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://staging-platform-api.va.gov"
            }}>{`https://staging-platform-api.va.gov`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`vagovstaging`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`production`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`After a merge to main`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`production`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://www.va.gov"
            }}>{`https://www.va.gov`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://platform-api.va.gov"
            }}>{`https://platform-api.va.gov`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`vagovprod`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`production`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Daily, Monday - Friday`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`There are four environments for va.gov:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`localhost`}</strong>{` runs on a local developer's machine`}</li>
      <li parentName="ul"><strong parentName="li">{`development, staging,`}</strong>{` and `}<strong parentName="li">{`production`}</strong>{` are shared environments that are accessible publicly.`}</li>
    </ul>
    <p><strong parentName="p">{`production`}</strong>{` and `}<strong parentName="p">{`staging`}</strong>{` APIs are connected with services within the VA to facilitate testing; `}<strong parentName="p">{`development`}</strong>{` API largely uses mock data in lieu of connecting to internal VA services.`}</p>
    <h2 {...{
      "id": "deployment"
    }}>{`Deployment`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`development, staging,`}</strong>{` and `}<strong parentName="li">{`production`}</strong>{` have changes to them deployed automatically after pull requests are merged into main.`}</li>
      <li parentName="ul">{`Review instances have changes deployed to them automatically when pull requests are created. Review instances are custom environments based on the shared dev environment.`}</li>
    </ul>
    <h2 {...{
      "id": "access-and-test-users"
    }}>{`Access and test users`}</h2>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://github.com/department-of-veterans-affairs/va.gov-team-sensitive/blob/master/Administrative/accessing-staging.md"
      }}>{`Accessing Staging`}</a>{` for`}</p>
    <ul>
      <li parentName="ul">{`HTTP basic auth `}<strong parentName="li">{`passwords`}</strong>{` needed to access `}<strong parentName="li">{`development`}</strong>{` and `}<strong parentName="li">{`staging`}</strong>{` environments, and`}</li>
      <li parentName="ul"><strong parentName="li">{`Test users`}</strong>{` that can be used to verify features in `}<strong parentName="li">{`localhost`}</strong>{`, `}<strong parentName="li">{`development`}</strong>{`, and `}<strong parentName="li">{`staging`}</strong>{` environments.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      